export default __webpack_public_path__ + "static/media/placeholder_business03-en-mobile.6637930b.png";